import routes from "./routes";
import axios from "axios";
import {
  BASE_URL,
  LIMIT_SESSION_TIMEOUT,
} from "./config";

import {
  BrowserRouter as Router,
  useRoutes,
} from "react-router-dom";
import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import "./assets/global.scss";
import { differenceInSeconds } from "date-fns";

let lastTimeActive = new Date();
let isActived = true;

axios.defaults.baseURL = BASE_URL;
const setBearerToken = () => {
  const token = localStorage.getItem("token");
  axios.interceptors.request.use(function (config: any) {
    config.headers.Authorization = `Bearer ${token}`;
    return config;
  });
};

setBearerToken();


const App = () => {
  const dispatch = useDispatch();
  const user = useSelector((state: any) => state.user);
  const navigate = useNavigate();

  const getMe = async () => {
    try {
      const { data } = await axios.get("/auth/me");
      dispatch({
        type: "UPDATE_USER",
        data: data?.user,
      });
    } catch (error: any) {
      console.log("get me error =>", error.message);
    }

    dispatch({
      type: "IS_FETCH_USER",
      data: true,
    });
  };

  const getApi = async () => {
    await getMe();
  
  };

  const checkActive = () => {
  
    if (!isActived) {
    
      const diff = differenceInSeconds(new Date(), lastTimeActive);
    
      if (diff >= LIMIT_SESSION_TIMEOUT) {
        // console.log("active event is limit timeout...", diff);
        localStorage.removeItem("token");
        navigate("/login");
      
      } else {
        setTimeout(() => {
          checkActive();
        }, 1000);
      }
    }
  };

  const activeEvent = () => {
    document.addEventListener("visibilitychange", function (event) {
      if (document.hidden) {
      
        isActived = false;
        lastTimeActive = new Date();
        checkActive();
      } else {
      
        isActived = true;
      }
    });
  };

  useEffect(() => {
    getApi();
    activeEvent();
    // navigate('/maintenance-mode'); // ! enable maintenance mode
  }, []);

  const isLoggedIn = false;
  let usedRoutes = useRoutes(routes(isLoggedIn));
  return usedRoutes;
};

const AppWrapper = () => {
  return (
    <Router>
      <App />
    </Router>
  );
};

export default AppWrapper;
